var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"label":"Quantity Type","items":_vm.quantityTypes},model:{value:(_vm.quantityType),callback:function ($$v) {_vm.quantityType=$$v},expression:"quantityType"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }